export default {
  "default-debug": () => import("/home/user/business/scaleuprobotics/tech/website_frontend/website/layouts/default-debug.vue").then(m => m.default || m),
  default: () => import("/home/user/business/scaleuprobotics/tech/website_frontend/website/layouts/default.vue").then(m => m.default || m)
}